import { HttpClient } from "@angular/common/http";
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { DataTableDirective } from 'angular-datatables';
import { NgxSpinnerService } from 'ngx-spinner';
import { v4 as uuid4 } from "uuid";

import { AuctionFilter } from '../../models/auction-filter';
import { environment } from '../../../../../environments/environment';
import { BusAuctionFilterService } from '../../services/bus-auction-filter.service';
import { Angular5Csv } from 'angular5-csv/dist/Angular5-csv';
import { AuctionMainTable } from '../../models/auction-main-table';

import { HomeMainModalDetailComponent } from "../home-main-modal-detail/home-main-modal-detail.component";
import { ComponentRegistryService } from "../../services/component-registry.service";
import { LoggingService } from '../../../../services/logging.service';
import { FederalLawFilter } from "../../models/federal-law-filter";
import { AlgoritmTypeFilter } from "../../models/algoritm-type-filter";
import { AuctionFilterService } from "../../services/home-auction-filter.service";


const API_SERVER = environment.apiServer;
const MODULE_PATH = "TakomaClient.app.modules.home.components.home-main-table";

declare var $: any;
class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

@Component({
  selector: "app-home-main-table",
  templateUrl: "./home-main-table.component.html",
  styleUrls: ["./home-main-table.component.sass"]
})
export class HomeMainTableComponent implements OnInit, OnDestroy, AfterViewInit {

  private subs: any[] = [];

  @ViewChild(DataTableDirective) datatableElement: DataTableDirective;

  dataSetAuction: any;  
  dtOptionsAuctions: DataTables.Settings = {};
  modelAuctionFilter: AuctionFilter = new AuctionFilter();
  modelAuctionMainTable: AuctionMainTable[];
  filterIsNotNull:boolean = true;
  defaultDateFrom: string;
  defaultDateTo: string;
  route: ActivatedRoute;

  federalLawList: FederalLawFilter[];
  algorithmTypesList: AlgoritmTypeFilter[];

  dt: DataTables.Api;

  constructor(
    private http: HttpClient, 
    private _bus: BusAuctionFilterService, 
    private spinner: NgxSpinnerService, 
    private _route: ActivatedRoute,
    private readonly _componentRegistry: ComponentRegistryService,
    private readonly _loggingService: LoggingService,
    private readonly _filterService: AuctionFilterService
  ) {
    this.modelAuctionMainTable = [];
    this.defaultDateFrom = this.getDateYYYYMMDD();
    this.defaultDateTo = this.getDateYYYYMMDD(true);
    this.route = _route;

    const routeId =  this.route.snapshot.paramMap.get('id');
    if ( routeId){
      setTimeout(() => {  
        this.onRowClick(routeId);
        $('#modalAuctionDetail').modal('show'); 
      }, 3000);
    }
  }

  onFieldChange(): void {
    const xid = uuid4();
    const qualName = `${MODULE_PATH}.HomeMainTableComponent.onFieldChange`;
    const inputParams = {};
    const description = "[EventHandler] Обработка изменения фильтра";
    
    try {
      this._loggingService.logStart(xid, qualName, inputParams, description);

      this.spinner.show();
      this.modelAuctionMainTable = [];
      this.dt.ajax.reload();
      
      this._loggingService.logFinish(xid, qualName, inputParams, description);
    } catch (error) {
      this._loggingService.logError(xid, qualName, error, inputParams, description);
      throw error;
    }
  }

  onAuctionStatusSelect(auctionStatus: string): void {
    const xid = uuid4();
    const qualName = `${MODULE_PATH}.HomeMainTableComponent.onAuctionStatusSelect`;
    const inputParams = { "auctionStatus": auctionStatus };
    const description = "[EventHandler] Обработка выбора фильтра статуса аукциона";

    try {
      this._loggingService.logStart(xid, qualName, inputParams, description);

      if (auctionStatus !== this.modelAuctionFilter.status) {
        this._bus.changeFilter({
          ...this.modelAuctionFilter,
          status: auctionStatus
        });
      }

      this._loggingService.logFinish(xid, qualName, inputParams, description);
    } catch (error) {
      this._loggingService.logError(xid, qualName, error, inputParams, description);
      throw error;
    }
  }

  onAuctionApprovalStatusSelect(auctionApprovalStatus: string): void {
    const xid = uuid4();
    const qualName = `${MODULE_PATH}.HomeMainTableComponent.onAuctionApprovalStatusSelect`;
    const inputParams = { "auctionApprovalStatus": auctionApprovalStatus };
    const description = "[EventHandler] Обработка выбора фильтра статуса согласования аукциона";

    try {
      this._loggingService.logStart(xid, qualName, inputParams, description);

      if (auctionApprovalStatus !== this.modelAuctionFilter.aucAgreementStatus) {
        this._bus.changeFilter({
          ...this.modelAuctionFilter,
          aucAgreementStatus: auctionApprovalStatus
        });
      }

      this._loggingService.logFinish(xid, qualName, inputParams, description);
    } catch (error) {
      this._loggingService.logError(xid, qualName, error, inputParams, description);
      throw error;
    }
  }

  onFederalLawSelect(federalLaw: FederalLawFilter): void {
    const xid = uuid4();
    const qualName = `${MODULE_PATH}.HomeMainTableComponent.onFederalLawSelect`;
    const inputParams = { "federalLaw": federalLaw };
    const description = "[EventHandler] Обработка выбора фильтра ФЗ";

    try {
      this._loggingService.logStart(xid, qualName, inputParams, description);

      if (federalLaw.federalLawName !== this.modelAuctionFilter.federalLaw) {
        this.modelAuctionFilter.federalLaw = federalLaw.federalLawName;
        this._bus.changeFilter(this.modelAuctionFilter);
      }

      this._loggingService.logFinish(xid, qualName, inputParams, description);
    } catch (error) {
      this._loggingService.logError(xid, qualName, error, inputParams, description);
      throw error;
    }
  }

  onAlgorithmTypeSelect(algorithmType: AlgoritmTypeFilter): void {
    const xid = uuid4();
    const qualName = `${MODULE_PATH}.HomeMainTableComponent.onAlgorithmTypeSelect`;
    const inputParams = { "algorithmType": algorithmType };
    const description = "[EventHandler] Обработка выбора фильтра Алгоритмы";

    try {
      this._loggingService.logStart(xid, qualName, inputParams, description);

      if (algorithmType.algorithmTypeId !== this.modelAuctionFilter.algorithmType) {
        this.modelAuctionFilter.algorithmType = algorithmType.algorithmTypeId;
        this._bus.changeFilter(this.modelAuctionFilter);
      }

      this._loggingService.logFinish(xid, qualName, inputParams, description);
    } catch (error) {
      this._loggingService.logError(xid, qualName, error, inputParams, description);
      throw error;
    }
  }


  onExport(): void {
    const _xid = this._loggingService.generateUUID();
    
    try {
      this._loggingService.logStart(_xid, 'App.Components.HomeMainTableComponent.onExport', null, 'Export started');
      
      this.modelAuctionMainTable = [];

      const optionsCvs = {
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalseparator: '.',
        showLabels: true,
        showTitle: true,
        useBom: true,
        noDownload: false,
        headers: [
          'Статус',
          'ID',
          'Дата подачи',
          'Дата аукциона',
          'Регион',
          'Заказчик',
          'Сумма',
          'Дистр-Участник',
          'Дистр-Победитель',
          'КАМ']
      };

      const filter = {
        DateAucFrom: this.modelAuctionFilter.dateAucFrom,
        DateAucTo: this.modelAuctionFilter.dateAucTo,
        DateSubmissionFrom: this.modelAuctionFilter.dateSubmissionFrom,
        DateSubmissionTo: this.modelAuctionFilter.dateSubmissionTo,
        IsNewAuc: this.modelAuctionFilter.isNewAuc,
        IsStatusAucLost: this.modelAuctionFilter.statusAucLost,
        IsStatusAucPreliminaryStudy: this.modelAuctionFilter.statusAucPreliminaryStudy,
        IsStatusAucRefusalOfParticipation: this.modelAuctionFilter.statusAucRefusalOfParticipation,
        IsStatusAucRejected: this.modelAuctionFilter.statusAucRejected,
        IsStatusAucWin: this.modelAuctionFilter.statusAucWin,
        IsStatusAucWorked: this.modelAuctionFilter.statusAucWorked,
        SearchMainField: this.modelAuctionFilter.searchMainField,
        Contractor: this.modelAuctionFilter.contractor,
        Mnn: this.modelAuctionFilter.mnn,
        region: this.modelAuctionFilter.region,
        distrWinner: this.modelAuctionFilter.distrWinner,
        distrMember: this.modelAuctionFilter.distrMember,
        manager: this.modelAuctionFilter.kam,
        status: this.modelAuctionFilter.status,
        aucAgreementStatus: this.modelAuctionFilter.aucAgreementStatus,
        amountPosition: this.modelAuctionFilter.amountPosition,
        federalLaw: this.modelAuctionFilter.federalLaw,
        algorithmType: this.modelAuctionFilter.algorithmType,
        start: 0,
        length: 100000,
        columns: [
          {
            data: 'StatusAuc', name: 'statusAuc'
          }
        ],
        order: [{
          column: 0, dir: 'asc'
        }]
      };

      this.http.post<any>(`${API_SERVER}/auction`, filter, {}).subscribe(result => {
        result.data.forEach(item => {
          const auctionItem = new AuctionMainTable();
          for (const key in item) {
            if (key in auctionItem) {
              if (key === 'code') {
                auctionItem[key] = item[key] + ' ';
              } else {
                auctionItem[key] = item[key];
              }
              if (auctionItem[key] == null) {
                auctionItem[key] = '';
              }
            }
          }
          this.modelAuctionMainTable.push(auctionItem);
        });
              
        const n = new Angular5Csv(this.modelAuctionMainTable, 'Auctions', optionsCvs);
        this._loggingService.logFinish(_xid, 'App.Components.HomeMainTableComponent.onExport', null, 'Export completed');
      }, error => {
        this._loggingService.logError(_xid, 'App.Components.HomeMainTableComponent.onExport', error, null, 'Export failed');
      });
    } catch (_error) {
      this._loggingService.logError(_xid, 'App.Components.HomeMainTableComponent.onExport', _error, null, 'Export method failed');
      throw _error;
    }
  }

  onDateChange(event) {
    const _xid = this._loggingService.generateUUID();
    
    try {
      this._loggingService.logStart(_xid, 'App.Components.HomeMainTableComponent.onDateChange', null, 'Date change started');
      
      this.modelAuctionFilter[event.target.name] = event.target.value;
      if (event.target.value != null) {
      }
      this.filterIsNotNull = false;
      this._bus.changeFilter(this.modelAuctionFilter);
      this.modelAuctionMainTable = [];
      
      this._loggingService.logFinish(_xid, 'App.Components.HomeMainTableComponent.onDateChange', null, 'Date changed');
    } catch (_error) {
      this._loggingService.logError(_xid, 'App.Components.HomeMainTableComponent.onDateChange', _error, null, 'Date change failed');
      throw _error;
    }
  }

  onRowClick(auctionNumber: string): void {
    const xid = uuid4();
    const qualName = `${MODULE_PATH}.HomeMainTableComponent.onRowClick`;
    const inputParams = { "auctionNumber": auctionNumber };
    const description = "[EventHandler] Обработка нажатия на аукцион";

    try {
      this._loggingService.logStart(xid, qualName, inputParams, description);

      this._componentRegistry.get(HomeMainModalDetailComponent).show(auctionNumber);

      this._loggingService.logFinish(xid, qualName, inputParams, description);
    } catch (error) {
      this._loggingService.logError(xid, qualName, error, inputParams, description);
      throw error;
    }
  }

  onResetFilters(): void {
    const xid = uuid4();
    const qualName = "app.modules.home.components.home-main-table.HomeMainTableComponent.onResetFilters";
    const inputParams = { };
    const description = "Сброс фильтров";
    
    try {
      this._loggingService.logStart(xid, qualName, inputParams, description);
      
      this.modelAuctionFilter.dateAucFrom = "";
      this.modelAuctionFilter.dateAucTo = "";
      this.modelAuctionFilter.dateSubmissionFrom = null;
      this.modelAuctionFilter.dateSubmissionTo = null;
      this.modelAuctionFilter.isNewAuc = 0;
      this.modelAuctionFilter.statusAucLost = 0;
      this.modelAuctionFilter.statusAucPreliminaryStudy = 0;
      this.modelAuctionFilter.statusAucRefusalOfParticipation = 0;
      this.modelAuctionFilter.statusAucRejected = 0;
      this.modelAuctionFilter.statusAucWin = 0;
      this.modelAuctionFilter.statusAucWorked = 0;
      this.modelAuctionFilter.searchMainField = null;
      this.modelAuctionFilter.kam = null;
      this.modelAuctionFilter.status = null;
      this.modelAuctionFilter.aucAgreementStatus = null;
      this.modelAuctionFilter.contractor = "";
      this.modelAuctionFilter.mnn = "";
      this.modelAuctionFilter.region = "";
      this.modelAuctionFilter.distrMember = "";
      this.modelAuctionFilter.distrWinner = "";
      this.modelAuctionFilter.kam = "";
      this.modelAuctionFilter.federalLaw = null;
      this.modelAuctionFilter.algorithmType = null;

      this.filterIsNotNull = true;

      this._bus.changeClearModalFilter("all");
      this._bus.changeFilter(this.modelAuctionFilter);
      
      this._loggingService.logFinish(xid, qualName, inputParams, description);
    } catch (error) {
      this._loggingService.logError(xid, qualName, error, inputParams, description);
      throw error;
    }
  }

  onClearModal(key: string) {
    const _xid = this._loggingService.generateUUID();

    try {
      this._loggingService.logStart(_xid, 'App.Components.HomeMainTableComponent.onClearModal', null, 'Clear modal started');

      this._bus.changeClearModalFilter(key);

      this._loggingService.logFinish(_xid, 'App.Components.HomeMainTableComponent.onClearModal', null, 'Clear modal completed');
    } catch (_error) {
      this._loggingService.logError(_xid, 'App.Components.HomeMainTableComponent.onClearModal', _error, null, 'Clear modal failed');
      throw _error;
    }
  }
  
  onClearSearchFields(key: string) {
    const _xid = this._loggingService.generateUUID();
    
    try {
      this._loggingService.logStart(_xid, 'App.Components.HomeMainTableComponent.onClearSearchFields', null, 'Clear search fields started');
      
      this._bus.changeClearSearchModalFields(key);
      
      this._loggingService.logFinish(_xid, 'App.Components.HomeMainTableComponent.onClearSearchFields', null, 'Clear search fields completed');
    } catch (_error) {
      this._loggingService.logError(_xid, 'App.Components.HomeMainTableComponent.onClearSearchFields', _error, null, 'Clear search fields failed');
      throw _error;
    }
  }

  onClearDateFields(key: string) {
    const _xid = this._loggingService.generateUUID();
    
    try {
      this._loggingService.logStart(_xid, 'App.Components.HomeMainTableComponent.onClearDateFields', null, 'Clear date fields started');
      
      this.filterIsNotNull = true;
      Object.keys(this.modelAuctionFilter).forEach(name => {
        if (name === key && this.modelAuctionFilter[name] != null) {
          
          switch (name) {
            case 'dateAucFrom':
                this.modelAuctionFilter[name] =  this.defaultDateFrom;
              break;
            case 'dateAucTo':
                this.modelAuctionFilter[name] =  this.defaultDateTo;
              break;
          
            default:
              this.modelAuctionFilter[name] = null;
              break;
          }
        }
      });

      this._bus.changeFilter(this.modelAuctionFilter);
      
      this._loggingService.logFinish(_xid, 'App.Components.HomeMainTableComponent.onClearDateFields', null, 'Clear date fields completed');
    } catch (_error) {
      this._loggingService.logError(_xid, 'App.Components.HomeMainTableComponent.onClearDateFields', _error, null, 'Clear date fields failed');
      throw _error;
    }
  }


  async ngOnInit() {
    const xid = uuid4();
    const qualName = "app.modules.home.components.home-main-table.HomeMainTableComponent.ngOnInit";
    const inputParams = { };
    const description = "Инициализация таблицы аукционов";

    this._loggingService.logStart(xid, qualName, inputParams, description);

    this.spinner.show();

    this.subs.push(this._bus.currentFilter$.subscribe(
      auctionFilter => {
        const xid = uuid4();
        const qualName = `${MODULE_PATH}.HomeMainTableComponent.lambda`;
        const inputParams = { "auctionFilter": auctionFilter };
        const description = "[MessageRecipient] Изменение фильтра таблицы аукционов";

        try {
          this._loggingService.logStart(xid, qualName, inputParams, description);

          this.modelAuctionFilter = {
            ...this.modelAuctionFilter,
            ...auctionFilter
          };

          if (this.dt != null) {
            this.onFieldChange();
          }

          this._loggingService.logFinish(xid, qualName, inputParams, description);
        } catch (error) {
          this._loggingService.logError(xid, qualName, error, inputParams, description);
          throw error;
        }
      }
    ));

    const currentDate = new Date()
    const dateFrom = new Date(currentDate.getTime() - 30*24*60*60*1000).toISOString().slice(0, 10);
    const dateTo = currentDate.toISOString().slice(0, 10);

    $('#dateAucFrom').val(dateFrom);
    $('#dateAucTo').val(dateTo);

    this.modelAuctionFilter.dateAucFrom = dateFrom;
    this.modelAuctionFilter.dateAucTo = dateTo;

    const that = this;

    this.dtOptionsAuctions = {
      pagingType: 'full_numbers',
      pageLength: 100,
      serverSide: true,
      processing: true,
      autoWidth: true,
      dom: 'tip',
      info: false,
      scrollY: 'calc(100vh - 230px)',
       //scrollCollapse: true,
       //scrollX: true,
      language: {
        emptyTable: 'Нет данных',
        info: 'Отображено с _START_ по _END_ из _TOTAL_ записей',
        infoEmpty: 'Отображено с 0 по 0 из 0 записей',
        infoFiltered: '(отфильтровано из _MAX_ записей)',
        infoPostFix: '',
        thousands: ',',
        lengthMenu: 'Показывать по _MENU_ записей',
        loadingRecords: 'Загрузка ...',
        processing: 'Обработка ...',
        search: 'Поиск:',
        zeroRecords: '',
        paginate: {
          first: 'Первая',
          last: 'Последняя',
          next: 'След.',
          previous: 'Пред.'
        },
        aria: {
          sortAscending: ': activate to sort column ascending',
          sortDescending: ': activate to sort column descending'
        }
      },
      ajax: (dataTablesParameters: any, callback) => {
        this.spinner.show();

        dataTablesParameters.DateAucFrom = this.modelAuctionFilter.dateAucFrom;
        dataTablesParameters.dateAucTo = this.modelAuctionFilter.dateAucTo;
        
        if(new Date(this.modelAuctionFilter.dateAucFrom) < new Date(this.modelAuctionFilter.dateAucTo)){
        }

        dataTablesParameters.DateSubmissionFrom = this.modelAuctionFilter.dateSubmissionFrom;
        dataTablesParameters.DateSubmissionTo = this.modelAuctionFilter.dateSubmissionTo;
        dataTablesParameters.IsNewAuc = this.modelAuctionFilter.isNewAuc;
        dataTablesParameters.IsStatusAucLost = this.modelAuctionFilter.statusAucLost;
        dataTablesParameters.IsStatusAucPreliminaryStudy = this.modelAuctionFilter.statusAucPreliminaryStudy;
        dataTablesParameters.IsStatusAucRefusalOfParticipation = this.modelAuctionFilter.statusAucRefusalOfParticipation;
        dataTablesParameters.IsStatusAucRejected = this.modelAuctionFilter.statusAucRejected;
        dataTablesParameters.IsStatusAucWin = this.modelAuctionFilter.statusAucWin;
        dataTablesParameters.IsStatusAucWorked = this.modelAuctionFilter.statusAucWorked;
        dataTablesParameters.SearchMainField = this.modelAuctionFilter.searchMainField;
        dataTablesParameters.Contractor = this.modelAuctionFilter.contractor;
        dataTablesParameters.Mnn = this.modelAuctionFilter.mnn;
        dataTablesParameters.region = this.modelAuctionFilter.region;
        dataTablesParameters.distrWinner = this.modelAuctionFilter.distrWinner;
        dataTablesParameters.distrMember = this.modelAuctionFilter.distrMember;
        dataTablesParameters.manager = this.modelAuctionFilter.kam;
        dataTablesParameters.amountPosition = this.modelAuctionFilter.amountPosition;
        dataTablesParameters.status = this.modelAuctionFilter.status;
        dataTablesParameters.aucAgreementStatus = this.modelAuctionFilter.aucAgreementStatus;
        dataTablesParameters.federalLaw = this.modelAuctionFilter.federalLaw;
        dataTablesParameters.algorithmType = this.modelAuctionFilter.algorithmType;

        that.http.post<DataTablesResponse>(`${API_SERVER}/auction`, dataTablesParameters, {})
          .subscribe(resp => {
            that.dataSetAuction = resp.data;

            console.log(resp.data)
            this.spinner.hide();
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: []
            });
          });
      },
      columns: [
        { data: 'StatusAuc', width: '60px'},
        { data: 'idAuc', width: '120px' },
        { data: 'dateSubmission', width: '110px' },
        { data: 'dateAuc', width: '130px' },
        { data: 'region' },
        { data: 'contractor', width: '510px' },
        { data: 'sumAuc' , width: '120px'  },
        { data: 'solopharmPriceSum' , width: '120px'  },
        { data: 'costPercentDiff' , width: '130px'  },
        { data: 'distrMember' , width: '120px' },
        { data: 'distrWinner' , width: '120px' },
        { data: 'kam' , width: '100px'},
        { data: 'amountPosition', width: '40px' },
        { data: 'totalAgreedIncreaseOfNMC', name: 'Total_Agreed_Increase_Of_NMC', width: '40px' },
        { data: 'totalAgreedIncreaseOfCK', name: 'Total_Agreed_Increase_Of_CK', width: '40px' },

      ]
    };
    await this.getFilterDataList();

    this._componentRegistry.register(HomeMainTableComponent, this);

    this._loggingService.logFinish(xid, qualName, inputParams, description);
  }

  async getFilterDataList(): Promise<void> {
    const xid = uuid4();
    const qualName = `${MODULE_PATH}.HomeMainTableComponent.getFilterDataList`;
    const description = 'Загрузка данных фильтров';

    this._loggingService.logStart(xid, qualName, null, `${description} начата`);

    try {
      const [federal, algorithm] = await Promise.all([
        this._filterService.getFederalLawList().toPromise(),
        this._filterService.getAlgorithmTypeList().toPromise()
      ]);

      this.federalLawList = federal || [];
      this.algorithmTypesList = algorithm || [];

      this._loggingService.logFinish(xid, qualName, null, `${description} завершена`);
    } catch (error) {
      this._loggingService.logError(xid, qualName, error, null, `${description} завершена с ошибкой`);
      throw error;
    } finally {
    }
  }



  ngOnDestroy(): void {
    this.subs.forEach(sub => sub.unsubscribe());
    this._componentRegistry.unregister(HomeMainTableComponent);
  }

  ngAfterViewInit(): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      this.dt = dtInstance;
    });

    $('.datetimepickers').each(function () {
      $(this).datetimepicker({
        locale: 'ru',
        format: 'YYYY-MM-DD',
        collapse: true,
        keepOpen: false,
        useCurrent: false,
        showClear: false

      });
    });

    $('[data-toggle="tooltip"]').tooltip();
  }

  getDateYYYYMMDD(to: boolean = false){
    if(!to) {
      var dateTo = new Date();
      dateTo.setDate(new Date().getDate() - 50 );
      return dateTo.toISOString().slice(0,10);
    }
    else {
      return new Date().toISOString().slice(0,10);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/home/components/home-main-table/home-main-table.component.ts